import { Check, Settings, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

type InventoryCardProps = {
  name: string;
  description: string;
  isConnected: boolean;
  hasListings: boolean;
  icon: JSX.Element;
  onConfigure?: () => void;
  onDisconnect?: () => void;
  isDisconnecting?: boolean;
};

const InventoryCard = ({
  name,
  description,
  isConnected,
  hasListings,
  icon,
  onConfigure,
  onDisconnect,
  isDisconnecting,
}: InventoryCardProps): JSX.Element => {
  return (
    <div
      className={`relative rounded-xl p-6 transition-all hover:shadow-md ${
        isConnected
          ? "border-2 border-green-400 bg-green-50"
          : "border border-gray-200 bg-white"
      }`}
    >
      {isConnected && (
        <div className="absolute right-4 top-4">
          <Check size={24} color="#48BB78" />
        </div>
      )}

      <div className="mb-4 flex flex-row items-start gap-4">
        <div className="flex min-h-14 min-w-14 items-center justify-center rounded-xl bg-gray-50 p-3">
          {icon}
        </div>

        <div className="flex flex-1 flex-col gap-1">
          <p className="text-lg font-bold">
            {name}
          </p>
          <p className="text-sm text-gray-600">
            {description}
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-2">
        {onConfigure && (
          <Button
            variant="outline"
            size="sm"
            onClick={onConfigure}
            className="w-full"
          >
            {isConnected && <Settings className="size-4" />}
            {isConnected ? "Configurar" : "Configurar ERP"}
          </Button>
        )}

        {isConnected && onDisconnect && (
          <Button
            variant="destructive"
            size="sm"
            onClick={onDisconnect}
            className="w-full"
            disabled={isDisconnecting}
          >
            {isDisconnecting && <Loader2 className="size-4 animate-spin" />}
            Desconectar
          </Button>
        )}
      </div>

      {isConnected && hasListings && (
        <div className="mt-3 rounded-lg border border-green-200 bg-green-50 p-3">
          <div className="flex flex-row gap-2">
            <Check color="#48BB78" />
            <p className="text-sm font-medium text-green-700">
              Conectado y sincronizado
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default InventoryCard;
